import { SupportedCurrencyCode } from '../../../Types/generated-types'

const currenciesByCountry: Record<string, SupportedCurrencyCode> = {
  GB: SupportedCurrencyCode.Gbp,
  US: SupportedCurrencyCode.Usd,
  AU: SupportedCurrencyCode.Aud,
  IE: SupportedCurrencyCode.Eur,
  NZ: SupportedCurrencyCode.Nzd,
}

const getCurrencyByCountry = (country?: string | null): SupportedCurrencyCode => {
  if (country && country in currenciesByCountry) return currenciesByCountry[country]

  return SupportedCurrencyCode.Eur
}

export default getCurrencyByCountry
